import { NavigateFunction, To, NavigateOptions } from 'react-router-dom';

export class AgPanelService {
    _navigate: NavigateFunction | null = null;

    initialiseNavigate(navigate: NavigateFunction) {
        this._navigate = navigate;
    }

    /**
     * @deprecated - don't use this. no seriously. don't
     * */
    navigate(to: To, options?: NavigateOptions) {
        if (!this._navigate) {
            console.error('AgPanelService.navigate() has not been initialised');
            return;
        }

        this._navigate(to, options);
    }
}
